export default {
  title: 'Liefersoft',
  form: {
    company_id: 'Virksomheds-ID',
    login: 'Login',
    password: 'Adgangskode',
  },
  buttons: {
    save: 'Gem',
    edit: 'Rediger',
    cancel: 'Annuller',
  },
  toasts: {
    error: 'Kunne ikke gemme ændringerne',
    success: 'Ændringerne er gemt',
  },
  instructions: {
    title: 'Opsætningsvejledning:',
    steps: {
      1: 'Gå til „Indstillinger“ > „Programindstillinger“ > „API/grænseflader“.',
      2: 'Tilføj en platform:\n• Klik på knappen „Platforme“.\n• Indtast et brugernavn (f.eks. platformens navn).\n• Klik på „Gem“.',
      3: 'Kopier API-data:\n• Efter lagring vises et vindue med API-platformens kode.\n• Kopier de viste data.',
    },
  },
  connected: {
    title: 'Liefersoft er forbundet',
    description: 'Denne integration er sat op.',
  },
};
